import script from "./PropertyInlineEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyInlineEditor.vue?vue&type=script&setup=true&lang=js"

import "./PropertyInlineEditor.vue?vue&type=style&index=0&id=5319adea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5319adea"]])

export default __exports__